		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyEmailDomainService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CompanyEmailDomain');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.CompanyEmailDomain[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.CompanyEmailDomain) : Observable<TooBig4Car.Logic.CompanyEmailDomain> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.CompanyEmailDomain> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.CompanyEmailDomain>{
		return this.myBaseService.get(id, this.url);
	}
	getDNS(id: System.Guid): Observable<any> {
		return this.myBaseService.get(id, this.url + '/Setup');
	}
	
}
				
